import React from 'react';
import { useHistory } from 'react-router-dom';

import queryString from 'query-string';

import Button from 'components/Buttons/Button';
import { Desktop, Mobile } from 'components/Responsive';
import useStoreTranslation from 'hooks/useStoreTranslation';

import {
  Container,
  LogoContainer,
  Title,
  Description,
  ButtonContainer,
  ContainerDesktop,
  IconArea,
  TitleDesktop,
  DescriptionDesktop,
  ButtonContainerDesktop,
  ContentDesktop,
} from './style';

const Welcome = () => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  const queryParams = queryString.parse(location.search) as {
    email?: string;
    name?: string;
    lastName?: string;
  };

  return (
    <>
      <Desktop>
        <ContainerDesktop>
          <ContainerDesktop.Column>
            <IconArea>
              <IconArea.Logo src="/corporate/images/logo-netviajes.svg" />
            </IconArea>

            <ContentDesktop>
              <TitleDesktop>{t('welcome.title')}</TitleDesktop>
              <DescriptionDesktop>{t('welcome.description')}</DescriptionDesktop>
              <ButtonContainerDesktop>
                <Button
                  type="button"
                  onClick={() =>
                    history.push(
                      `/corporate/adminonboarding?email=${queryParams.email}&name=${queryParams.name}&lastName=${queryParams.lastName}`,
                    )
                  }
                >
                  {t('welcome.start')}
                </Button>
              </ButtonContainerDesktop>
            </ContentDesktop>
          </ContainerDesktop.Column>
          <ContainerDesktop.ColumnImage />
        </ContainerDesktop>
      </Desktop>
      <Mobile>
        <Container>
          <LogoContainer>
            <img alt="rappi" src="/corporate/images/rappi_travel.svg" />
          </LogoContainer>
          <Title>{t('welcome.title')}</Title>
          <Description>{t('welcome.description')}</Description>
          <ButtonContainer>
            <Button
              type="button"
              onClick={() =>
                history.push(
                  `/corporate/adminonboarding?email=${queryParams.email}&name=${queryParams.name}&lastName=${queryParams.lastName}`,
                )
              }
            >
              {t('welcome.start')}
            </Button>
          </ButtonContainer>
        </Container>
      </Mobile>
    </>
  );
};

export default Welcome;
